export const TRANSLATIONS_EN = {
    home: "Home",
    about: "About us",
    services: "Our services",
    why: "Why us",
    clients: "Our partners",
    heroTitle: "Be the center of our interests",
    heroContent: "Tech Pro is a Yemeni company specialized in technologies development and marketing in various fields",
    aboutUsTitle: "Who Are We?",
    aboutUsContent: `Tech Pro is a Yemeni company specialized in development and marketing technologies in various fields, through providing all promotional and advertising solutions and achieving them with the highest level of innovation, creativity, and professionalism. It meets the aspirations of businessmen and keeps pace with the rapid technological development. We have an integrated team with long experience and high efficiency. `,
    vision: "Our Vision",
    visionContent: `The first company to provide the latest and finest marketing techniques and creative solutions.`,
    message: "Our Mission",
    messageContent: `Establishing trustfulness between us and our customers, and providing marketing services with high quality and punctuality.`,
    servicesTitle: "Our services",

    marketingT: `E-Marketing
`,
    marketingC: `We provide e-marketing services through social media in a more quality and creative way to enhance awareness of your brand, with innovative and purposeful content and design. The accounts are managed professionally and the paid campaigns are managed via Google, Facebook, Twitter, YouTube, etc. The results are monitored in professional reports that reach you on a real-time basis to ensure effective visibility in search engines and the achievement of the targeted positive results. `,
    onlineMarketingT: `Integrated Digital Marketing Services
`,
    onlineMarketingC: `We grant you the opportunity to focus on your primary role in sponsoring your project, and we take over the task of managing your commercial accounts on digital platforms, according to a marketing plan that suits your activity on social networks. We also monitor, analyze, and improve the results in a way that enables your spread, achieves the required results, and reaches the target segment.

`,
    journalismT: `Media coverage services
`,
    journalismC: `We monitor and document occasions and events (video - photography) and cover them through various media, with the addition of news and promotional issues about your project.

`,
    fullJournalismContentT: `Preparing Integrated Advertising Materials
`,
    fullJournalismContentC: `Creating audio-visual flashes with various methods and ideas (introductory - promotional) that are published on the social media platforms of your post and are broadcast on various advertising media that meets the needs of the audience and viewer.

`,
    giftsT: `Preparing All Kinds of Promotional Gifts
`,
    giftsC: `We provide promotional gifts with new and appropriate ideas that are distinguished in delivering your advertising message.

`,
    designT: `Design services
`,
    designC: `The image is presented with art, creativity, and skill using the appropriate colors to amaze your customers and to convey your deep message simply. Also, we enhance your image with creative designs with an identity that expresses you.

`,
    codingT: `Website design and programming
`,
    codingC: `A new vision in designing websites to suit your commercial identity with a design that is easy to reach customers and in line with search engines, all Internet browsers, and mobile devices as well as tablets.

`,
    printT: `Printing services
`,
    printC: `mplementation of integrated printing works and services of all kinds (paper - advertising propagandistic) using the latest sustainable printing technology.

`,
    studyT: `Carrying out Studies and Measuring Public Opinion
`,
    studyC: `We conduct survey studies of the public, with methodological research tools that show you the successes achieved by your project. We also develop strategic and promotional plans to improve the project to accomplish future successes based on the results of those surveys.

`,
    seoT: `Raising the Ranking of Sites in Search Engines
`,
    seoC: `We configure your site for search engines with software modifications that suit the standards of international search engines. Further, we work to advertise and market your site to reach the largest number of customers.

`,
    trainT: `Institutional Training, qualifying and Development
`,
    trainC: `Organizing and conducting training courses for the staff so as to develop their level of awareness by specialized trainers in the field of management and human development.

`,
    whysection: `What distinguishes us?`,
    whyContentOne: `Implementation of comprehensive advertising services with innovative notions along with advanced and practical advertising solutions. Innovation is the most significant thing that distinguishes us from others, and the implementation of our tasks with perfection and quality.


`,
    whyContentTwo: `We have an endless relationship with our customers as we work to develop their business through comprehensive marketing and promotion according to the finest integrated marketing solutions to achieve the best promotional results, which contribute to raising the profits of their investments.

`,
    thoughts: `Creative ideas
`,
    solutions: `Professional solutions
`,
    designContent: `Premium content
& design
`,
    pro: `Professional & highly
qualified
`,
    clientsSectionTitle: `Our Clients
`,
    footerNum: `778099900
`,
    footerLocalNum: `01 - 449 990
`,
    address: `Sana'a Al-Jazayer st.
`,
    copyrights: `©2021 all rights reserved
`,
};